import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30eab7ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-breadcrumbs__wrap" }
const _hoisted_2 = { class: "menu-breadcrumbs" }

import { computed, onMounted, onUnmounted, PropType, ref, watch } from 'vue';
import {
  BreadcrumbProjectModel,
  GroupModel,
  GroupUpdateNameEventResponseModel,
  SettingsBreadcrumbsModel,
  UpdateQueueNameModel,
} from './models';
import { MenuBreadcrumbsAdapterService } from './adapter';
import { NamespaceModel } from './models';
import { pending } from './utils';
import { MenuBreadcrumbsItem } from './components';
import { ProjectModel } from '@/models';
import { MenuBreadcrumbsColorEnum } from './enums';
import { UpdateNamespaceInfo } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'menu-breadcrumbs',
  props: {
  /**Настройки */
  settings: {
    type: Object as PropType<SettingsBreadcrumbsModel>,
  },
  /**Проект */
  project: {
    type: Object as PropType<ProjectModel>,
  },
  /**Не использовать роуты */
  noRoute: {
    type: Boolean,
    default: false,
  },
  /**Цвет */
  color: {
    type: String as PropType<MenuBreadcrumbsColorEnum>,
  },
},
  setup(__props) {

const props = __props;



const adapter = new MenuBreadcrumbsAdapterService();

/**Хлебные крошки */
const breadcrumbs = ref<NamespaceModel>();

/**Проект */
const breadcrumbProject = computed(() =>
  props.project
    ? new BreadcrumbProjectModel({
        Id: Number(props.project?.Id),
        Name: props.project?.Name,
        ImageUrl: props.project?.ImageUrl,
        PreviewColor: props.project?.PreviewColor,
      })
    : undefined,
);

/**Отобразить хлебную крошку проекта */
const isVisibleBreadcrumbProject = computed(
  () => !(props.settings?.QueueId || props.settings?.GroupId || props.settings?.NamespaceId),
);

const isLoading = ref(false);

const pendingGetBreadcrumbs = pending(async (settings: SettingsBreadcrumbsModel) => {
  const resp = await adapter.getBreadcrumbs(settings);
  if (resp.IsSuccess) breadcrumbs.value = resp.Value;
});

const getBreadcrumbs = async (settings?: SettingsBreadcrumbsModel) => {
  isLoading.value = true;
  if (settings.GroupId || settings.QueueId || settings.NamespaceId) {
    await pendingGetBreadcrumbs(settings);
  }
  isLoading.value = false;
};

watch(
  () => props.settings,
  () => {
    if (props.settings) {
      getBreadcrumbs(props.settings);
    }
  },
  { deep: true },
);

/**При обновлении неймспейса */
const onUpdateNamespace = async (data: UpdateNamespaceInfo) => {
  if (breadcrumbs.value.Id === data.Id) {
    breadcrumbs.value = Object.assign(
      breadcrumbs.value,
      new NamespaceModel({
        ...breadcrumbs.value,
        Id: data.Id,
        Name: data.Name,
        IconId: data.IconId,
        IconUrl: data.IconUrl,
        Color: data.Color,
        ColorId: data.ColorId,
      }),
    );
  }
};
/** Обновить название очереди */
const updateQueueName = (
  data: UpdateQueueNameModel,
  group: NamespaceModel | GroupModel = breadcrumbs.value,
) => {
  if (!group) return;

  if (group.QueueTask?.Id === data.QueueId) {
    group.QueueTask.Name = data.Name;
  }
  if (group.Group) {
    updateQueueName(data, group.Group);
  }
};
/**Обновить название папки */
const updateGroupName = (
  data: GroupUpdateNameEventResponseModel,
  group: NamespaceModel | GroupModel = breadcrumbs.value,
) => {
  if (!group) return;

  if (group?.Id === data.GroupId) {
    group.Name = data.Name;
  }
  if (group.Group) {
    updateGroupName(data, group.Group);
  }
};

onMounted(() => {
  if (props.settings) {
    getBreadcrumbs(props.settings);
  }
  adapter.UpdateNamespaceEvent.on(onUpdateNamespace);
  adapter.UpdateQueueEvent.on(updateQueueName);
  adapter.OnUpdateNameGroupEvent.on(updateGroupName);
});

onUnmounted(() => {
  adapter.UpdateNamespaceEvent.removeListener(onUpdateNamespace);
  adapter.UpdateQueueEvent.removeListener(updateQueueName);
  adapter.OnUpdateNameGroupEvent.removeListener(updateGroupName);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isVisibleBreadcrumbProject.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (breadcrumbProject.value)
              ? (_openBlock(), _createBlock(_unref(MenuBreadcrumbsItem), {
                  key: 0,
                  breadcrumb: breadcrumbProject.value,
                  "no-route": __props.noRoute,
                  color: __props.color
                }, null, 8, ["breadcrumb", "no-route", "color"]))
              : _createCommentVNode("", true)
          ], 64))
        : (breadcrumbs.value)
          ? (_openBlock(), _createBlock(_unref(MenuBreadcrumbsItem), {
              key: 1,
              breadcrumb: breadcrumbs.value,
              settings: __props.settings,
              "no-route": __props.noRoute,
              color: __props.color
            }, null, 8, ["breadcrumb", "settings", "no-route", "color"]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})